import { css } from 'styled-components';

const Colors = {
  black: '#2a2018', // ink
  brandPrimary: '#c05a3a', // terracotta
  cornFlowerBlue: '#f0d5c7', // light terracotta
  darkerBlue: '#a04a2e', // dark terracotta
  deepPurple: '#6b5b8a', // dusk
  goldFont: '#D4AF37',
  green: '#3d6149', // dark sage
  grey: '#d8cfc0', // tan
  greyDark: '#8a7d6e', // mid
  greyDarker: '#4a3f33', // brown
  greyLight: '#f2ede4', // sand
  lightBlue: '#b5a898', // light-mid
  red: '#da071c',
  successGreen: '#4e7c5f', // sage
  white: '#ffffff',
  yellow: '#ffc01e',
  // Named warm palette
  cream: '#faf8f4',
  dusk: '#6b5b8a',
  ink: '#2a2018',
  lightMid: '#b5a898',
  mid: '#8a7d6e',
  sage: '#4e7c5f',
  sand: '#f2ede4',
  tan: '#d8cfc0',
  terracotta: '#c05a3a',
  warm: '#ebe4d8',
};

export const colorsCSSVars = css`
  --color-black: ${Colors.black};
  --color-grey-darker: ${Colors.greyDarker};
  --color-grey-dark: ${Colors.greyDark};
  --color-grey: ${Colors.grey};
  --color-grey-light: ${Colors.greyLight};
  --color-white: ${Colors.white};
  --color-red: ${Colors.red};
  --color-green: ${Colors.green};
  --color-success-green: ${Colors.successGreen};
  --color-yellow: ${Colors.yellow};
  --color-deep-purple: ${Colors.deepPurple};
  --color-gold-font: ${Colors.goldFont};
  --color-primary-light-blue: ${Colors.cornFlowerBlue};
  --color-cornflower-blue: ${Colors.cornFlowerBlue};
  --color-darker-blue: ${Colors.darkerBlue};
  --color-brand-primary: ${Colors.brandPrimary};
  --color-sand: ${Colors.sand};
  --color-warm: ${Colors.warm};
  --color-tan: ${Colors.tan};
  --color-brown: ${Colors.greyDarker};
  --color-mid: ${Colors.mid};
  --color-light-mid: ${Colors.lightMid};
  --color-terracotta: ${Colors.terracotta};
  --color-sage: ${Colors.sage};
  --color-dusk: ${Colors.dusk};
  --color-cream: ${Colors.cream};
  --color-ink: ${Colors.ink};
`;

export default Colors;
